import { VectorSearchFilters } from "../../../lib/types";
import GG_DEFAULTS from '../../../lib/genericGridDefaults';

export const applySearchFilters = (limit: number, offset: number, displayIn: string, benchmarkYear: number, filters?: VectorSearchFilters) => {
  const defaultLimit = 50
  const defaultOffset = 0
  const surveyCode = !filters?.surveyCodeSurveyShortName?.length ? 
    null :
    filters.surveyCodeSurveyShortName.map(s => s.split(' - ')[s.split(' - ').length -1])
  const vectorSearchFilter = { ...filters, surveyCode }
  delete vectorSearchFilter.surveyCodeSurveyShortName

  return (
    {
      benchmarkYears: [benchmarkYear],
      displayIn,
      isVectorSearch: true,
      vectorSearchFilter,
      offset: offset || defaultOffset,
      limit: limit || defaultLimit,
    }
  )
}

export const hasRequiredFilters = (f: VectorSearchFilters) => !!f.jobTitle.trim().length || !!f.jobDescription.trim().length
export const isRowLoading = (row: any, loadingId: number) => row.allCells.find((cell: any) => cell.column.id === GG_DEFAULTS.CUT_ID)?.value === loadingId
export const isChecked = (cutId: number, matches: Record<number, boolean>) => matches[cutId]
export const useSelectAccessor = (el: any) => el.allCells.find((cell: any) => cell.column.id === GG_DEFAULTS.CUT_ID)?.value
